import React, { useState, useEffect } from "react";
import "./App.css";
import HomePage from "./page/Home/homePage";
import { Spinner } from "react-bootstrap";
import reload from "./animation/reload2.json";
import connectionFaild from "./animation/connectionFaild.json";
import Lottie from "lottie-react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DetailsPage from "./page/Details/detailsPage";

// import Lottie from "lottie-react";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // Simulating loading time for demonstration purposes
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div>
      {isLoading ? (
        <div className="d-flex align-items-center justify-content-center pt-5">
          {/* <Spinner className="m-auto mt-5 "  animation="border" role="status">
        </Spinner> */}
          <Lottie className="reload" animationData={reload} />
        </div>
      ) : isOnline ? (
        <BrowserRouter>
          <Routes>
            <Route index path="/" element={<HomePage />} />
            <Route path="/details" element={<DetailsPage />} />
            {/* <Route  path="/details/:item" element={<DetailsPage />} /> */}
          </Routes>
        </BrowserRouter>
      ) : (
        <div className="d-flex flex-column gap-3 align-items-center justify-content-center vh-100">
          <div> You are offline. Please check your internet connection.</div>
          <div>
            <Lottie animationData={connectionFaild} />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
